import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { transformProduct } from '../../../data/constants';
import ProductCard from '../ProductCard';
import ScrollableRow from '../../utils/ScrollableRow';

const RecommendedPostings = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const res = await axios.get(
          `${process.env.REACT_APP_Backend_Host_Name}/api/v1/products/filtered`
        );
        if (res.data.success) {
          const transformed = (res.data.products || []).slice(0, 12).map(transformProduct);
          setProducts(transformed);
        }
      } catch (err) {
        console.error('Error fetching recommended products:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  if (!loading && products.length === 0) return null;

  return (
    <section className="mainSection recommendedPostingsSection">
      <ScrollableRow
        title="Recommended for You"
        items={products}
        itemsPerRow={4}
        isLoading={loading}
        noItemsMessage="No products available yet."
        renderItem={(product, index) => (
          <ProductCard key={product.id || index} product={product} />
        )}
      />
    </section>
  );
};

export default RecommendedPostings;
